export default __webpack_public_path__ + "static/Food1-bb9b97c1d86a1b52385dbf19c69602eb.jpg";